import * as React from 'react';

function SvgYoutubeMono(props) {
  return (
    <svg
      width="1em"
      height="1em"
      viewBox="0 0 30 30"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M24.906 8.154c-.755-.79-1.59-.87-2.063-.917a6.707 6.707 0 01-.142-.014C19.623 7 15.005 7 15.005 7c-.01 0-4.628 0-7.706.223-.043.005-.09.01-.142.014-.472.046-1.308.127-2.063.917-.66.668-.874 2.184-.874 2.184S4 12.118 4 13.898v1.67c0 1.78.22 3.56.22 3.56s.215 1.516.874 2.184c.694.726 1.568.832 2.126.899.115.014.216.026.3.041 1.76.17 7.48.221 7.48.221s4.623-.006 7.701-.23l.142-.014c.472-.046 1.308-.127 2.063-.917.66-.668.874-2.184.874-2.184s.22-1.78.22-3.56v-1.67c0-1.78-.22-3.56-.22-3.56s-.215-1.516-.874-2.184zM12.729 17.59l-.001-6.181 5.212 3.48-5.211 2.701z"
        fill="currentColor"
      />
    </svg>
  );
}

export default SvgYoutubeMono;
